'use client';

import type React from 'react';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './Portal.module.scss';

export const PortalRoot = 'portal-root';

interface PortalElementProps {
  id: string;
}

export const PortalElement = ({ id }: PortalElementProps) => (
  <div className={styles.portalElement} id={id} />
);

type PortalProps = {
  children: React.ReactNode;
  id?: string; // Optionally specify the ID of the container element
};

export const Portal: React.FC<PortalProps> = ({ children, id = PortalRoot }) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // Find the existing portal container (guaranteed to exist in layout)
    const element = document.getElementById(id);
    if (element) {
      setContainer(element);
    }
  }, [id]);

  // Wait until the container is available
  if (!container) return null;

  return createPortal(children, container);
};
